// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"5f65ea7d","264":"24ccd3ca","480":"aa80e3a1","638":"cb7a5e81","738":"782679e1"}[chunkId] + ".chunk.js";
};